// TOP LEVEL IMPORTS
import React from 'react';
// APOLLO
import { graphql, compose } from 'react-apollo';
import saveUserAccount from 'ApolloClient/Mutations/saveUserAccount';
import adminDeleteUser from 'ApolloClient/Mutations/adminDeleteUser';
import resendWelcomeEmail from 'ApolloClient/Mutations/resendWelcomeEmail';
import getUserByIdAdminQuery from 'ApolloClient/Queries/getUserByIdAdmin';
import PageContainer from 'components/common/PageContainer';
import Button from 'components/common/Button';
import AdminHeader from 'components/common/AdminHeader';
// ANTD
import Popconfirm from 'antd/lib/popconfirm';
import message from 'components/common/message';
import notification from 'antd/lib/notification';
import SwitchInput from 'components/inputs/SwitchInput';
import FormItem from 'components/common/FormItem';

// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';

// COMPONENTS
import UserForm from 'components/forms/UserForm';
// import InviteForm from 'components/forms/InviteForm';
import ErrorHelpers from '../../lib/helpers/ErrorHelpers/index';

const DataRow = ({ label, value }) => (
  <div>
    {label}: {value}
  </div>
);

// EXPORTED COMPONENT
// ===================================
class AdminUserDetail extends React.Component {
  state = {
    visible: false, // whether or not the user form is visible
    disabled: false, // whether or not the user form submit button is disabled
  };

  showForm = () => {
    this.setState({ visible: true });
  };

  hideForm = () => {
    this.setState({ visible: false });
  };

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  handleDelete = () => {
    const { _id } = this.props.getUserByIdAdminQuery.getUserByIdAdmin;
    const variables = { _id };
    // const refetchQueries = [{ query: GET_USERS, variables: { params: null } }];
    this.props
      .adminDeleteUser({ variables })
      .then(() => this.props.history.push('/admin/users'))
      .catch(err => ErrorHelpers.handleError(err));
  };

  resendWelcomeEmail = () => {
    const { _id } = this.props.getUserByIdAdminQuery.getUserByIdAdmin;
    const variables = { userId: _id };
    // const refetchQueries = [{ query: GET_USERS, variables: { params: null } }];
    this.props
      .resendWelcomeEmail({ variables })
      .then(() => message.success('Email resent'))
      .catch(err => ErrorHelpers.handleError(err));
  };

  handleEdit = async user => {
    // Handle form submit, success and errors
    const { saveUserAccount, match } = this.props;
    const userId = match.params.userId;
    const variables = { _id: userId, params: user };

    try {
      await saveUserAccount({
        variables,
        refetchQueries: [{ query: getUserByIdAdminQuery, variables: { _id: userId } }],
      });
      notification.success({ message: 'Changes saved successfully!' });
      this.hideForm();
    } catch (exc) {
      console.log(exc);
      console.log({ message: exc });
      ErrorHelpers.handleError(exc);
    }
    this.enableBtn();
  };

  renderContent = user => {
    const { visible, disabled } = this.state;

    if (!visible) {
      return (
        <div>
          <h2 style={{ marginTop: 20 }}>DATA</h2>
          <DataRow label="id" value={user._id} />
          <DataRow label="first name" value={user.profile.firstName} />
          <DataRow label="last name" value={user.profile.lastName} />
          <DataRow label="workPhone" value={user.profile.workPhone} />
          <DataRow label="cellPhone" value={user.profile.cellPhone} />
          <DataRow label="infusionsoftId" value={user.profile.infusionsoftId} />
          <DataRow label="subscribed" value={user.profile.subscribed ? 'yes' : 'no'} />
          <DataRow label="subscriptionPlan" value={user.profile.subscriptionPlan} />
        </div>
      );
    }

    return (
      <React.Fragment>
        <UserForm
          type="edit"
          user={user}
          disabled={disabled}
          onBeforeHook={this.disableBtn}
          onErrorHook={this.enableBtn}
          onSubmitHook={this.handleEdit}
          handleSubmit={this.handleEdit}
          onCancel={this.hideForm}
        />
      </React.Fragment>
    );
  };

  render() {
    const { getUserByIdAdmin } = this.props.getUserByIdAdminQuery;

    if (!getUserByIdAdmin) {
      return <div>CAN NOT FIND RECORD</div>;
    }

    return (
      <PageContainer>
        {!this.state.visible ? (
          <React.Fragment>
            <AdminHeader
              header={getUserByIdAdmin.profile.firstName || ''}
              action={(
                <div>
                  <div style={{ marginBottom: 15 }}>
                    <Button fullWidth onClick={this.showForm}>
                      EDIT USER
                    </Button>
                  </div>
                  <div style={{ marginBottom: 15 }}>
                    <Popconfirm
                      title="Are you sure you want to resend the welcome email?"
                      onConfirm={this.resendWelcomeEmail}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="danger" fullWidth>
                        Send Welcome Email
                      </Button>
                    </Popconfirm>
                  </div>
                  <div style={{ marginTop: 15 }}>
                    <Popconfirm
                      title="Are you sure you want to delete this user?"
                      onConfirm={this.handleDelete}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="danger" fullWidth>
                        DELETE USER
                      </Button>
                    </Popconfirm>{' '}
                  </div>
                  &nbsp;&nbsp;
                </div>
              )}
            />
            <div>
              <h2 style={{ marginTop: 20 }}>DATA</h2>
              <DataRow label="id" value={getUserByIdAdmin._id} />
              <DataRow label="first name" value={getUserByIdAdmin.profile.firstName} />
              <DataRow label="last name" value={getUserByIdAdmin.profile.lastName} />
              <DataRow label="email" value={getUserByIdAdmin.emails[0].address} />
              <DataRow label="workPhone" value={getUserByIdAdmin.profile.workPhone} />
              <DataRow label="cellPhone" value={getUserByIdAdmin.profile.cellPhone} />
              <DataRow label="infusionsoftId" value={getUserByIdAdmin.profile.infusionsoftId} />
              <DataRow label="subscribed" value={getUserByIdAdmin.profile.subscribed ? 'yes' : 'no'} />
              <DataRow label="subscriptionPlan" value={getUserByIdAdmin.profile.subscriptionPlan} />
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <AdminHeader
              header={getUserByIdAdmin.profile.firstName || ''}
              action={(
                <Button
                  fullWidth
                  type="dashed"
                  style={{ marginBottom: 20 }}
                  onClick={() => this.setState({ visible: false })}
                >
                  Close
                </Button>
              )}
            />
            <div style={{ width: 500, maxWidth: '100%' }}>
              <FormItem label="subscribed">
                <SwitchInput
                  checked={this.state.subscribed || getUserByIdAdmin.profile.subscribed}
                  onChange={subscribed => this.handleEdit({ subscribed, email: getUserByIdAdmin.emails[0].address })}
                />
              </FormItem>
              {this.renderContent(getUserByIdAdmin)}
            </div>
          </React.Fragment>
        )}
      </PageContainer>
    );
  }
}

const enhance = compose(
  graphql(getUserByIdAdminQuery, {
    name: 'getUserByIdAdminQuery',
    options: props => {
      const variables = { _id: props.match.params.userId };
      return {
        variables,
        name: 'user',
      };
    },
  }),
  RecomposeHelpers.errorHOC({ propName: 'getUserByIdAdminQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'getUserByIdAdminQuery' }),
  graphql(saveUserAccount, { name: 'saveUserAccount' }),
  graphql(adminDeleteUser, { name: 'adminDeleteUser' }),
  graphql(resendWelcomeEmail, { name: 'resendWelcomeEmail' }),
);

export default enhance(AdminUserDetail);



// WEBPACK FOOTER //
// ./src/routes/admin-user-detail/index.js